import firebaseApp from "../../firebase/credenciales";

import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

//const {contextData} = useDataContext();
    

export default async function getCategorias(productofolio) {
    

  //console.log(valor);
    const CategoriasDB =  [];
    //console.log(valor);
    const collectionRef = collection(db, "Categorias_productos".replace(/ /g, ""));
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      CategoriasDB.push(doc.data());
    });
    return CategoriasDB;
    
    

}


//"+productofolio+"
